import { generateFullName } from 'utils/generateFullNameUtils';

/**
 * Format a single contact/user for TimeEntries dropdown
 * Uses firm_user_id as assignee_id instead of client_cognito_username
 * @param {Object} data - User/contact data
 * @returns {Object} - Formatted contact object
 */
export const formatTimeEntriesContact = (data) => {
  if (data.res_type === 'user-group') {
    return {
      group_name: data?.group_name,
      group_id: data?.user_group_id,
      sk: data?.sk,
      assignee_id: data?.user_accessible_list,
      assignee_name: data?.group_name,
    };
  } else {
    return {
      assignee_id: data?.firm_user_id || data?.client_cognito_username || data?.contact_id,
      assignee_name: generateFullName(data),
      cognito_username: data?.client_cognito_username,
      contact_id: data?.contact_id,
      firm_user_id: data?.firm_user_id,
      email: data?.email,
      access_level: data?.access_level,
    };
  }
};

/**
 * Format multi-select contact list for TimeEntries dropdown
 * Groups users and groups, uses firm_user_id as assignee_id
 * @param {Array} data - Array of user/contact data
 * @returns {Array} - Formatted grouped list
 */
export const formatTimeEntriesMultiSelectContactList = (data) => {
  const groupedContacts = {};

  data?.forEach((contact) => {
    const contactType = contact.res_type === 'user-group' ? 'Groups' : 'Users';

    if (!groupedContacts[contactType]) {
      groupedContacts[contactType] = {
        assignee_name: contactType,
        code: contactType,
        items: [],
      };
    }

    groupedContacts[contactType].items.push({
      ...contact,
      ...formatTimeEntriesContact(contact),
    });
  });

  return Object.values(groupedContacts);
};
